var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-link not-printable",attrs:{"href":"#"},on:{"click":_vm.downloadPdf}},[_c('span',{staticClass:"glyphicon cars_compare_glyphicon cars_compare_glyphicon__print"}),_vm._v(" Print ")])}
var staticRenderFns = []

export { render, staticRenderFns }